import { useEffect } from "react";
import useIsMobile from "../Hook/mobile";
import AdsBanners from "../Component/AdsBanners";

function Main({ children, noAds }: any) {
  const detectMobile = useIsMobile();
  useEffect(() => {
    (window as any).showAds2 && (window as any).showAds2();
  }, [])

  useEffect(() => {
    let topads = document.getElementById("top-mob-ads");
    if(!topads) return;
    if(noAds){
      topads.style.display = "none";
    }else{
      topads.style.display = "block";
    }
  }, [noAds])
  return (
    // pb clears the fixed bottom bar. It keys off lg, not the theme breakpoint,
    // because that is where MenuMobile actually stops rendering.
    <div className='w-full flex flex-col gap-4 lg:px-4 relative pb-nav-safe lg:pb-12'>
      <div>
        {!noAds && (
          // Inset from the screen edge like the heading and the filter row. The feed
          // panel below is deliberately not — 12a runs it edge to edge.
          <div className="flex flex-col items-center gap-3 mt-4 px-page-x lg:px-0">
            <div id={detectMobile.isMobile ? "ad-300x100-m-home-1" : "ad-728x90-d-home-1"}></div>
            <AdsBanners slot={detectMobile.isMobile ? "ad-300x100-m-home-1" : "ad-728x90-d-home-1"} />
          </div>
        )}
      </div>
      {children}
      {!noAds && <div className="flex justify-center items-center mb-4 px-page-x lg:px-0"><div id={detectMobile.isMobile ? "ad-300x100-m-home-2" : "ad-728x90-d-home-2"}></div></div>}
    </div>
  )
}

export default Main